import React, { useEffect } from 'react';

const SynapticERDiagram = () => {
  useEffect(() => {
    document.title = 'Synaptic Proteomic Database - ER Diagram';
  }, []);
  return (
    <div className="w-full overflow-auto">
      <div className="min-w-[1200px] mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1300 950">
          {/* Background */}
          <rect width="1300" height="950" fill="#f9f9f9" />

          {/* Title */}
          <text x="650" y="40" fontFamily="Arial" fontSize="24" fontWeight="bold" textAnchor="middle">Synaptic Proteomic Database - Entity Relationship Diagram</text>
          <text x="650" y="70" fontFamily="Arial" fontSize="14" textAnchor="middle">With API Integration and CSV Data Flow</text>

          {/* Database Tables & Relationships - REARRANGED FOR BETTER SPACING */}

          {/* LEFT COLUMN */}

          {/* Gene Table */}
          <rect x="100" y="120" width="200" height="160" fill="#aed6f1" stroke="#3498db" strokeWidth="2" rx="5" />
          <text x="200" y="145" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Gene</text>
          <line x1="120" y1="155" x2="280" y2="155" stroke="#3498db" strokeWidth="1" />
          <text x="120" y="175" fontFamily="Arial" fontSize="12">ID (PK)</text>
          <text x="120" y="195" fontFamily="Arial" fontSize="12">HumanName</text>
          <text x="120" y="215" fontFamily="Arial" fontSize="12">HumanEntrez</text>
          <text x="120" y="235" fontFamily="Arial" fontSize="12">MouseEntrez</text>
          <text x="120" y="255" fontFamily="Arial" fontSize="12">RatEntrez</text>
          <text x="120" y="275" fontFamily="Arial" fontSize="12">MGI</text>

          {/* Disease Table - moved down for better spacing */}
          <rect x="100" y="330" width="200" height="120" fill="#d4efdf" stroke="#27ae60" strokeWidth="2" rx="5" />
          <text x="200" y="355" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Disease</text>
          <line x1="120" y1="365" x2="280" y2="365" stroke="#27ae60" strokeWidth="1" />
          <text x="120" y="385" fontFamily="Arial" fontSize="12">HDOID (PK)</text>
          <text x="120" y="405" fontFamily="Arial" fontSize="12">Description</text>

          {/* Paper Table - moved down for better spacing */}
          <rect x="100" y="500" width="200" height="140" fill="#fadbd8" stroke="#e74c3c" strokeWidth="2" rx="5" />
          <text x="200" y="525" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Paper</text>
          <line x1="120" y1="535" x2="280" y2="535" stroke="#e74c3c" strokeWidth="1" />
          <text x="120" y="555" fontFamily="Arial" fontSize="12">PMID (PK)</text>
          <text x="120" y="575" fontFamily="Arial" fontSize="12">Year</text>
          <text x="120" y="595" fontFamily="Arial" fontSize="12">Name</text>
          <text x="120" y="615" fontFamily="Arial" fontSize="12">Description</text>

          {/* Species Table - moved to bottom of left column */}
          <rect x="100" y="690" width="200" height="120" fill="#a9dfbf" stroke="#27ae60" strokeWidth="2" rx="5" />
          <text x="200" y="715" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Species</text>
          <line x1="120" y1="725" x2="280" y2="725" stroke="#27ae60" strokeWidth="1" />
          <text x="120" y="745" fontFamily="Arial" fontSize="12">TaxID (PK)</text>
          <text x="120" y="765" fontFamily="Arial" fontSize="12">Name</text>
          <text x="120" y="785" fontFamily="Arial" fontSize="12">SciName</text>

          {/* MIDDLE LEFT COLUMN */}

          {/* Mutation Table */}
          <rect x="400" y="120" width="200" height="200" fill="#f9e79f" stroke="#f1c40f" strokeWidth="2" rx="5" />
          <text x="500" y="145" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Mutation</text>
          <line x1="420" y1="155" x2="580" y2="155" stroke="#f1c40f" strokeWidth="1" />
          <text x="420" y="175" fontFamily="Arial" fontSize="12">ID (PK)</text>
          <text x="420" y="195" fontFamily="Arial" fontSize="12">GeneID (FK)</text>
          <text x="420" y="215" fontFamily="Arial" fontSize="12">HDOID (FK)</text>
          <text x="420" y="235" fontFamily="Arial" fontSize="12">Chromosome</text>
          <text x="420" y="255" fontFamily="Arial" fontSize="12">Position</text>
          <text x="420" y="275" fontFamily="Arial" fontSize="12">Variant</text>
          <text x="420" y="295" fontFamily="Arial" fontSize="12">FunctionClass</text>

          {/* BrainRegion Table - increased spacing */}
          <rect x="400" y="370" width="200" height="140" fill="#d2b4de" stroke="#8e44ad" strokeWidth="2" rx="5" />
          <text x="500" y="395" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">BrainRegion</text>
          <line x1="420" y1="405" x2="580" y2="405" stroke="#8e44ad" strokeWidth="1" />
          <text x="420" y="425" fontFamily="Arial" fontSize="12">ID (PK)</text>
          <text x="420" y="445" fontFamily="Arial" fontSize="12">Name</text>
          <text x="420" y="465" fontFamily="Arial" fontSize="12">Description</text>
          <text x="420" y="485" fontFamily="Arial" fontSize="12">InterlexID</text>
          <text x="420" y="505" fontFamily="Arial" fontSize="12">ParentID (FK)</text>

          {/* Localisation Table - increased spacing */}
          <rect x="400" y="560" width="200" height="100" fill="#f5cba7" stroke="#d35400" strokeWidth="2" rx="5" />
          <text x="500" y="585" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Localisation</text>
          <line x1="420" y1="595" x2="580" y2="595" stroke="#d35400" strokeWidth="1" />
          <text x="420" y="615" fontFamily="Arial" fontSize="12">ID (PK)</text>
          <text x="420" y="635" fontFamily="Arial" fontSize="12">Name</text>
          <text x="420" y="655" fontFamily="Arial" fontSize="12">Description</text>

          {/* Method Table - increased spacing */}
          <rect x="400" y="710" width="200" height="100" fill="#aeb6bf" stroke="#566573" strokeWidth="2" rx="5" />
          <text x="500" y="735" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Method</text>
          <line x1="420" y1="745" x2="580" y2="745" stroke="#566573" strokeWidth="1" />
          <text x="420" y="765" fontFamily="Arial" fontSize="12">ID (PK)</text>
          <text x="420" y="785" fontFamily="Arial" fontSize="12">Name</text>
          <text x="420" y="805" fontFamily="Arial" fontSize="12">Description</text>

          {/* MIDDLE RIGHT COLUMN - Junction Tables */}

          {/* PaperGene - Increased height and spacing between rows */}
          <rect x="700" y="120" width="200" height="200" fill="#ebdef0" stroke="#8e44ad" strokeWidth="2" rx="5" />
          <text x="800" y="145" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">PaperGene</text>
          <line x1="720" y1="155" x2="880" y2="155" stroke="#8e44ad" strokeWidth="1" />
          <text x="720" y="175" fontFamily="Arial" fontSize="12">GeneID (FK)</text>
          <text x="720" y="195" fontFamily="Arial" fontSize="12">PaperPMID (FK)</text>
          <text x="720" y="215" fontFamily="Arial" fontSize="12">Dataset</text>
          <text x="720" y="235" fontFamily="Arial" fontSize="12">SpeciesTaxID (FK)</text>
          <text x="720" y="255" fontFamily="Arial" fontSize="12">BrainRegionID (FK)</text>
          <text x="720" y="275" fontFamily="Arial" fontSize="12">LocalisationID (FK)</text>
          <text x="720" y="295" fontFamily="Arial" fontSize="12">MethodID (FK)</text>

          {/* DiseaseGene - Better vertical spacing */}
          <rect x="700" y="370" width="200" height="80" fill="#d5f5e3" stroke="#2ecc71" strokeWidth="2" rx="5" />
          <text x="800" y="395" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">DiseaseGene</text>
          <line x1="720" y1="405" x2="880" y2="405" stroke="#2ecc71" strokeWidth="1" />
          <text x="720" y="425" fontFamily="Arial" fontSize="12">HDOID (FK)</text>
          <text x="720" y="445" fontFamily="Arial" fontSize="12">GeneID (FK)</text>

          {/* PaperMutation - Better vertical spacing */}
          <rect x="700" y="500" width="200" height="80" fill="#fad7a0" stroke="#f39c12" strokeWidth="2" rx="5" />
          <text x="800" y="525" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">PaperMutation</text>
          <line x1="720" y1="535" x2="880" y2="535" stroke="#f39c12" strokeWidth="1" />
          <text x="720" y="555" fontFamily="Arial" fontSize="12">PMID (FK)</text>
          <text x="720" y="575" fontFamily="Arial" fontSize="12">MutationID (FK)</text>

          {/* SpecieRegion - Better vertical spacing */}
          <rect x="700" y="630" width="200" height="80" fill="#a3e4d7" stroke="#1abc9c" strokeWidth="2" rx="5" />
          <text x="800" y="655" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">SpecieRegion</text>
          <line x1="720" y1="665" x2="880" y2="665" stroke="#1abc9c" strokeWidth="1" />
          <text x="720" y="685" fontFamily="Arial" fontSize="12">BrainRegionID (FK)</text>
          <text x="720" y="705" fontFamily="Arial" fontSize="12">TaxID (FK)</text>

          {/* RIGHT COLUMN */}

          {/* GoGene (SynGO) Table */}
          <rect x="1000" y="120" width="200" height="140" fill="#d6eaf8" stroke="#3498db" strokeWidth="2" rx="5" />
          <text x="1100" y="145" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">GoGene</text>
          <line x1="1020" y1="155" x2="1180" y2="155" stroke="#3498db" strokeWidth="1" />
          <text x="1020" y="175" fontFamily="Arial" fontSize="12">GeneID (FK to HumanEntrez)</text>
          <text x="1020" y="195" fontFamily="Arial" fontSize="12">SpecieID (FK)</text>
          <text x="1020" y="215" fontFamily="Arial" fontSize="12">GOID (FK)</text>
          <text x="1020" y="235" fontFamily="Arial" fontSize="12">Evidence</text>

          {/* GO Table - Better spacing */}
          <rect x="1000" y="310" width="200" height="100" fill="#d1f2eb" stroke="#1abc9c" strokeWidth="2" rx="5" />
          <text x="1100" y="335" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">GO</text>
          <line x1="1020" y1="345" x2="1180" y2="345" stroke="#1abc9c" strokeWidth="1" />
          <text x="1020" y="365" fontFamily="Arial" fontSize="12">GOID (PK)</text>
          <text x="1020" y="385" fontFamily="Arial" fontSize="12">Term</text>
          <text x="1020" y="405" fontFamily="Arial" fontSize="12">Domain</text>

          {/* External CSV File - Better spacing */}
          <rect x="1000" y="460" width="200" height="100" fill="#f8d7da" stroke="#dc3545" strokeWidth="2" rx="5" strokeDasharray="5,5" />
          <text x="1100" y="485" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">Human_syn_top5.txt</text>
          <line x1="1020" y1="495" x2="1180" y2="495" stroke="#dc3545" strokeWidth="1" />
          <text x="1020" y="515" fontFamily="Arial" fontSize="12">HumanEntrez</text>
          <text x="1020" y="535" fontFamily="Arial" fontSize="12">OMIM ID</text>
          <text x="1020" y="555" fontFamily="Arial" fontSize="12">OMIM Phenotype</text>

          {/* API Section - More vertical space */}
          <rect x="1000" y="610" width="200" height="210" fill="#e8e8e8" stroke="#6c757d" strokeWidth="2" rx="5" />
          <text x="1100" y="635" fontFamily="Arial" fontSize="16" fontWeight="bold" textAnchor="middle">API Integration</text>
          <line x1="1020" y1="645" x2="1180" y2="645" stroke="#6c757d" strokeWidth="1" />
          <text x="1020" y="670" fontFamily="Arial" fontSize="12" fill="#3498db">- JSON APIs (Search/Filter)</text>
          <text x="1030" y="695" fontFamily="Arial" fontSize="12" fill="#3498db">• /api/gene/search</text>
          <text x="1030" y="720" fontFamily="Arial" fontSize="12" fill="#3498db">• /api/disease/search</text>
          <text x="1030" y="745" fontFamily="Arial" fontSize="12" fill="#3498db">• /api/paper/search</text>
          <text x="1020" y="770" fontFamily="Arial" fontSize="12" fill="#2c3e50">- CSV Export APIs</text>
          <text x="1030" y="790" fontFamily="Arial" fontSize="12" fill="#2c3e50">• Basic table exports</text>

          {/* Relationships - REDESIGNED WITH BETTER SPACING AND LESS CROSSING */}

          {/* Gene to Mutation */}
          <path d="M300 150 L400 190" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="155" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="385" y="185" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Gene to DiseaseGene */}
          <path d="M300 200 C500 200, 600 400, 700 425" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="205" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="430" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Gene to PaperGene */}
          <path d="M300 170 C500 170, 600 170, 700 175" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="175" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="180" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Disease to DiseaseGene */}
          <path d="M300 350 C500 350, 600 375, 700 425" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="355" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="420" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Disease to Mutation */}
          <path d="M300 340 L400 215" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="345" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="385" y="220" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Paper to PaperGene */}
          <path d="M300 520 C500 520, 600 250, 700 195" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="525" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="200" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Paper to PaperMutation */}
          <path d="M300 540 C500 540, 600 540, 700 555" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="545" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="560" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Mutation to PaperMutation */}
          <path d="M600 220 C650 220, 650 500, 700 575" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="615" y="225" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="570" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* BrainRegion to PaperGene */}
          <path d="M600 400 C650 300, 650 260, 700 255" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="615" y="395" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="250" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* BrainRegion to SpecieRegion */}
          <path d="M600 440 C650 440, 650 685, 700 685" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="615" y="445" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="680" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Species to PaperGene */}
          <path d="M300 700 C480 650, 650 350, 700 235" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="695" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="230" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Species to SpecieRegion */}
          <path d="M300 730 C500 730, 600 705, 700 705" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="735" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="710" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Brain Region to Self (Parent) */}
          <path d="M600 440 C630 440, 630 460, 600 470" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="625" y="450" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="625" y="465" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Gene to GoGene */}
          <path d="M300 130 C650 80, 900 130, 1000 175" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="135" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="985" y="170" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* GO to GoGene */}
          <path d="M1100 310 L1100 240" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="1110" y="290" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="1110" y="260" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Species to GoGene */}
          <path d="M300 710 C750 400, 900 200, 1000 195" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="315" y="705" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="985" y="190" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Localisation to PaperGene */}
          <path d="M600 580 C650 500, 650 280, 700 275" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="615" y="575" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="270" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Method to PaperGene */}
          <path d="M600 730 C650 500, 650 300, 700 295" stroke="#333" strokeWidth="1.5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="615" y="725" fontFamily="Arial" fontSize="11" textAnchor="middle">1</text>
          <text x="685" y="290" fontFamily="Arial" fontSize="11" textAnchor="middle">N</text>

          {/* Human_syn_top5.txt connections - More organized */}
          <path d="M1000 510 C750 450, 450 225, 300 210" stroke="#dc3545" strokeWidth="1.5" strokeDasharray="5,5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="660" y="360" fontFamily="Arial" fontSize="12" fill="#dc3545">Consensus Gene Data</text>

          <path d="M1000 540 C800 500, 450 380, 300 380" stroke="#dc3545" strokeWidth="1.5" strokeDasharray="5,5" fill="none" markerEnd="url(#arrowhead)" />
          <text x="750" y="480" fontFamily="Arial" fontSize="12" fill="#dc3545">Disease Classification</text>

          {/* API connections - Better organized */}
          <path d="M1000 695 C850 650, 400 300, 300 190" stroke="#3498db" strokeWidth="1.5" strokeDasharray="3,3" fill="none" markerEnd="url(#arrowhead)" />
          <text x="680" y="495" fontFamily="Arial" fontSize="12" fill="#3498db">Gene Search</text>

          <path d="M1000 720 C850 680, 450 450, 300 390" stroke="#3498db" strokeWidth="1.5" strokeDasharray="3,3" fill="none" markerEnd="url(#arrowhead)" />
          <text x="750" y="600" fontFamily="Arial" fontSize="12" fill="#3498db">Disease Search</text>

          <path d="M1000 745 C850 700, 450 580, 300 550" stroke="#3498db" strokeWidth="1.5" strokeDasharray="3,3" fill="none" markerEnd="url(#arrowhead)" />
          <text x="750" y="625" fontFamily="Arial" fontSize="12" fill="#3498db">Paper Search</text>

          <path d="M1030 790 C850 750, 600 600, 500 300" stroke="#2c3e50" strokeWidth="1.5" strokeDasharray="3,3" fill="none" markerEnd="url(#arrowhead)" />
          <text x="850" y="700" fontFamily="Arial" fontSize="12" fill="#2c3e50">CSV Exports</text>

          {/* Arrowhead definition */}
          <defs>
            <marker id="arrowhead" markerWidth="10" markerHeight="7" refX="9" refY="3.5" orient="auto">
              <polygon points="0 0, 10 3.5, 0 7" fill="#333" />
            </marker>
          </defs>

          {/* Legend - Reorganized for better spacing */}
          <rect x="50" y="840" width="1200" height="90" fill="white" stroke="#ccc" strokeWidth="1" rx="5" />
          <text x="60" y="865" fontFamily="Arial" fontSize="14" fontWeight="bold">Legend</text>

          <rect x="180" y="855" width="15" height="15" fill="#aed6f1" stroke="#3498db" strokeWidth="1" />
          <text x="205" y="868" fontFamily="Arial" fontSize="12">Core Entity Tables</text>

          <rect x="380" y="855" width="15" height="15" fill="#ebdef0" stroke="#8e44ad" strokeWidth="1" />
          <text x="405" y="868" fontFamily="Arial" fontSize="12">Junction Tables</text>

          <rect x="580" y="855" width="15" height="15" fill="#f8d7da" stroke="#dc3545" strokeWidth="1" strokeDasharray="5,5" />
          <text x="605" y="868" fontFamily="Arial" fontSize="12">External CSV Data Source</text>

          <rect x="830" y="855" width="15" height="15" fill="#e8e8e8" stroke="#6c757d" strokeWidth="1" />
          <text x="855" y="868" fontFamily="Arial" fontSize="12">API Integration</text>

          <rect x="1030" y="855" width="15" height="15" fill="#d1f2eb" stroke="#1abc9c" strokeWidth="1" />
          <text x="1055" y="868" fontFamily="Arial" fontSize="12">Gene Ontology Tables</text>

          <line x1="180" y1="890" x2="200" y2="890" stroke="#333" strokeWidth="1.5" />
          <text x="205" y="893" fontFamily="Arial" fontSize="12">One-to-Many Relationship</text>

          <line x1="380" y1="890" x2="400" y2="890" stroke="#dc3545" strokeWidth="1.5" strokeDasharray="5,5" />
          <text x="405" y="893" fontFamily="Arial" fontSize="12">CSV Data Integration</text>

          <line x1="580" y1="890" x2="600" y2="890" stroke="#3498db" strokeWidth="1.5" strokeDasharray="3,3" />
          <text x="605" y="893" fontFamily="Arial" fontSize="12">API Data Flow</text>
        </svg>
      </div>
    </div>
  );
};

export default SynapticERDiagram;